export const getSecondsElapsedUntilReset = (): number => {
  const date = new Date();
  
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  return 24 * 60 * 60 - ((hours) * 60 * 60 + (minutes) * 60 + (seconds));
}